import { useState, useEffect } from "react";
import { Button } from "@/components/ui/button";
import { Mail, Phone, MessageCircle, X } from "lucide-react";
import { trackPhoneClick, trackWhatsAppClick } from "@/components/ConversionTracking";

export const StickyContact = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsVisible(window.scrollY > 300);
    };

    window.addEventListener("scroll", handleScroll, { passive: true });
    
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  if (!isVisible) return null;

  return (
    <>
      {/* Main floating button */}
      <div className="fixed bottom-5 right-4 z-40 sm:bottom-6 sm:right-6">
        {!isOpen ? (
          <div className="relative">
            <Button
              onClick={() => setIsOpen(true)}
              className="relative h-14 w-14 rounded-full shadow-xl hover:shadow-2xl bg-accent hover:bg-accent/90 transition-all duration-300 hover:scale-110"
              aria-label="Open contact options"
            >
              <MessageCircle className="h-6 w-6" />
            </Button>
          </div>
        ) : (
          <div className="bg-white rounded-2xl shadow-2xl p-4 space-y-3 min-w-[300px] border border-border/20 animate-in slide-in-from-bottom-2 duration-300">
            <div className="flex items-center justify-between mb-2">
              <div>
                <h3 className="font-playfair font-semibold text-primary">Get in Touch</h3>
                <p className="text-xs text-muted-foreground">REM7 product and project enquiries</p>
              </div>
              <Button
                variant="ghost"
                size="sm"
                onClick={() => setIsOpen(false)}
                className="h-8 w-8 p-0"
              >
                <X className="h-4 w-4" />
              </Button>
            </div>

            <a
              href="https://wa.me/34688495309?text=Hello%20Aureum%20VII%20Trading,%20I%27m%20interested%20in%20your%20smart%20toilet%20solutions."
              target="_blank"
              rel="noopener noreferrer"
              onClick={trackWhatsAppClick}
              className="flex items-center gap-3 p-3 rounded-lg bg-[#25D366]/10 hover:bg-[#25D366]/20 transition-colors group border border-[#25D366]/20"
            >
              <div className="h-10 w-10 rounded-full bg-[#25D366] flex items-center justify-center">
                <MessageCircle className="h-5 w-5 text-white" />
              </div>
              <div className="flex-1">
                <div className="text-sm font-semibold text-foreground">WhatsApp</div>
                <div className="text-xs text-muted-foreground">Open a conversation about REM7</div>
              </div>
            </a>

            <a
              href="tel:+34688495309"
              onClick={trackPhoneClick}
              className="flex items-center gap-3 p-3 rounded-lg hover:bg-accent/10 transition-colors group"
            >
              <div className="h-10 w-10 rounded-full bg-accent/10 flex items-center justify-center group-hover:bg-accent/20 transition-colors">
                <Phone className="h-5 w-5 text-accent" />
              </div>
              <div className="flex-1">
                <div className="text-sm font-medium text-foreground">Call Us</div>
                <div className="text-xs text-muted-foreground">+34 688 495 309</div>
              </div>
            </a>

            <a
              href="mailto:info@aureum7trading.com"
              className="flex items-center gap-3 p-3 rounded-lg hover:bg-accent/10 transition-colors group"
            >
              <div className="h-10 w-10 rounded-full bg-accent/10 flex items-center justify-center group-hover:bg-accent/20 transition-colors">
                <Mail className="h-5 w-5 text-accent" />
              </div>
              <div className="flex-1">
                <div className="text-sm font-medium text-foreground">Email</div>
                <div className="text-xs text-muted-foreground">info@aureum7trading.com</div>
              </div>
            </a>

            <div className="pt-2 border-t border-border/20 text-center">
              <p className="text-[10px] text-muted-foreground">
                Mon-Fri 9:00-18:00 CET • Weekend emergencies available
              </p>
            </div>
          </div>
        )}
      </div>
    </>
  );
};
